<template lang="pug">
  vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(multiple v-model="selected"  max-height="350px" :data="customers")
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(icon="search" size="small" :placeholder="$t('strings.search')" v-model="filters.where.param" @keyup.enter="applyFilter(filters)")
              div
                vm-select(:placeholder="$t('strings.order_by')" autocomplete v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px")
                  div(v-for="(item,index) in columns")
                    vm-select-item(:key="item + ',asc'" v-if="item !== ''" :value="item + ',asc'" :text="$t('customers.'+ item) + ', asc'")
                    vm-select-item(:key="item + ',desc'" v-if="item !== ''" :value="item + ',desc'" :text="$t('customers.'+ item) + ', desc'")
                vm-tooltip.filter2(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                  vm-button(type="default" size="small" icon="list" style="display: none;")
                vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                  vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('customers.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                .open(@click="showDetails(data[indextr], tr)")
                  slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                  slot(v-if="column != 'status' && column != 'total' && column != 'unit_price' && column != 'assignmet_type_id' && column != 'seller' && column != 'has_sales'") {{ data[indextr][column] }}
                  vm-chip(v-if="column == 'assignmet_type_id'" :color="colorAssigment(data[indextr]['assignmet_type']['name'])") {{ data[indextr]['assignmet_type']['name'] }}
                  slot(v-if="column == 'createdBy'") {{ data[indextr]['created_by_user'] && data[indextr]['created_by_user']['name'] }}
                  slot(v-if="column == 'seller' && data[indextr][column] != null ") {{ data[indextr]['seller']['name'] }}
                  vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr][column])") {{data[indextr]['status_display']}}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="$router.push(`/customers/${data[indextr]['id']}/addresses`)")
                    vm-icon(icon="eye-outline")
                    slot &nbsp;{{ $t('strings.addresses') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="$router.push(`/customers/${data[indextr]['id']}/contacts`)")
                    vm-icon(icon="eye-outline")
                    slot &nbsp;{{ $t('strings.contacts') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin')" @click="assignCustomer(data[indextr], tr)")
                    vm-icon(icon="collapse-outline")
                    slot &nbsp;{{ $t('strings.assign') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="editCustomer(data[indextr], tr)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteCustomerConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
          .total-records(v-if="total>0") Total: {{ total | currency }}
</template>
<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Customers')

export default {
  name: 'CustomerLead',
  components: {
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    form: {},
    selected: [],
    enabledDelete: false,
    columns: [
      'id',
      'tradename',
      'contact',
      'email',
      'address',
      'state',
      'phone',
      'rfc',
      'payment_terms',
      'assignmet_type_id',
      'seller',
      'createdBy'
    ],
    status: [
      {
        text: 'Pendiente',
        value: 1
      },
      {
        text: 'Pagado',
        value: 2
      }
    ],
    filters: {
      where: {
        tradename: '',
        contact: '',
        email: '',
        rfc: '',
        param: ''
      },
      whereIn: {
        status: [],
        type_prospect: [2]
      },
      whereBetween: {
        priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filtersClear: {
      where: {
        param: ''
      },
      whereIn: {
        type_prospect: [2]
      }
    }
  }),
  computed: {
    ...mapGetters([
      'customers',
      'customersCatalog',
      'pagination',
      'filterParams'
    ]),
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    filterParams (filter) {
      this.$emit('checkFilters', filter)
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getCustomers(this.currentPage)
    },
    currentPage (currentPage) {
      this.getCustomers(currentPage)
    },
    selected (selected) {
      this.$emit('checkSelected', selected)
    }
  },
  async created () {
    this.applyFilter(this.filters)
    this.currentPage = this.pagination.currentPage
    await this.getCustomers(1)
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'deleteCustomer',
      'deleteCustomers',
      'loadCustomers',
      'loadCatalog',
      'actionCustomer',
      'setModalVisible',
      'setModalAssignVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    colorAssigment (code) {
      switch (code.trim()) {
        case 'Prospectado':
          return 'secondary'
        case 'Asignado':
          return 'danger'
        default:
          return 'secondary'
      }
    },
    editCustomer (customer, index) {
      this.$emit('editCustomer', customer)
    },
    assignCustomer (customer, index) {
      this.$emit('assignCustomer', customer)
    },
    async deleteCustomerConfirm (customer) {
      let t = this
      this.auxDeleteCustomer = () => {
        t.deleteCustomer(customer).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: this.$t(customer.contact) }),
        accept: this.auxDeleteCustomer
      })
    },
    async deleteCustomersConfirm () {
      let t = this
      let customersMany = parseDeleteMany(this.selected, 'contact')
      this.auxDeleteCustomer = () => {
        t.deleteCustomers(customersMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.customer'), attribute: customersMany.values }),
        accept: this.auxDeleteCustomer
      })
    },
    async setActionCustomer (record, action) {
      record.id && this.actionCustomer({ id: record.id, action })
    },
    async getCustomers (page) {
      let t = this
      this.loadCustomers({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let customer = this.customers.filter(customer => customer.id === parseInt(index))[0]
      customer && this.editCustomer(customer, index)
    },
    async getCatalog () {
      Object.keys(this.customersCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=*${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    },
    showDetails (customer) {
      this.$router.push({ name: 'customersDetailsShow', params: { id: customer.id } })
    }
  }
}
</script>
